const API_BASE_URL = 'https://www.poneyclubtoulouse.fr/api/';
const CACHE_DURATION = 1 * 60 * 1000; // 1 minute au lieu de 5
const cache = new Map();

/**
 * Effectue une requête avec des tentatives de reconnexion en cas d'échec.
 */
const fetchWithRetry = async (url, options = {}, retries = 3) => {
  try {
    const response = await fetch(url, options);
    if (response.ok) {
      return await response.json();
    }

    if (response.status === 500 && retries > 0) {
      await new Promise(resolve => setTimeout(resolve, 1000));
      return fetchWithRetry(url, options, retries - 1);
    }

    throw new Error(`HTTP ${response.status}: ${response.statusText}`);
  } catch (error) {
    if (retries > 0) {
      await new Promise(resolve => setTimeout(resolve, 1000));
      return fetchWithRetry(url, options, retries - 1);
    }
    throw error;
  }
};

/**
 * Récupère des données depuis un cache local ou une nouvelle requête.
 */
const fetchWithCache = async (url, options = {}) => {
  const cacheKey = url + JSON.stringify(options);
  const cachedData = cache.get(cacheKey);

  if (cachedData && Date.now() - cachedData.timestamp < CACHE_DURATION) {
    return cachedData.data;
  }

  const data = await fetchWithRetry(url, options);
  cache.set(cacheKey, { data, timestamp: Date.now() });

  return data;
};

/**
 * Récupère les événements avec pagination.
 */
export const fetchEvents = (page = 1, perPage = 40) => {
  return fetchWithCache(`${API_BASE_URL}?action=getEvents&page=${page}&per_page=${perPage}`);
};

/**
 * Récupère tous les artistes.
 */
export const fetchArtists = () => {
  return fetchWithCache(`${API_BASE_URL}?action=getArtists`);
};

/**
 * Récupère les partenaires.
 */
export const fetchPartners = () => {
  return fetchWithCache(`${API_BASE_URL}?action=getPartenaires`);
};

/**
 * Récupère le merchandising.
 */
export const fetchMerchandise = () => {
  return fetchWithCache(`${API_BASE_URL}?action=getMerchandising`);
};

/**
 * Récupère les options globales.
 */
export const fetchOptions = () => {
  return fetchWithCache(`${API_BASE_URL}?action=getOptions`);
};

/**
 * Récupère les détails d'un artiste par son slug.
 */
export const fetchArtistBySlug = (slug) => {
  return fetchWithCache(`${API_BASE_URL}?action=getArtistBySlug&slug=${slug}`);
};

/**
 * Récupère les détails d'un événement par son slug et sa date.
 */
export const fetchEventBySlug = async (slug) => {
  try {
    const response = await fetchWithCache(`${API_BASE_URL}?action=getEvents&slug=${slug}`);
    return Array.isArray(response) && response.length > 0 ? response[0] : null;
  } catch (error) {
    console.error('Erreur dans fetchEventBySlug:', error);
    throw error;
  }
};

/**
 * Récupère les plats du menu food.
 */
export const fetchFood = () => {
  return fetchWithCache(`${API_BASE_URL}?action=getFoods`);
};

/**
 * Vide le cache local.
 */
export const clearCache = () => {
  cache.clear();
};

/**
 * Vérifie si le serveur est accessible.
 */
export const checkServerStatus = async () => {
  try {
    const response = await fetch(API_BASE_URL);
    return response.ok;
  } catch {
    return false;
  }
};